import React, { useEffect, useState } from 'react';
import { FC } from 'react';
import 'react-image-lightbox/style.css';
import useTranslations from '@hooks/useTranslation';
import { COMPONENT_TYPE, IColors, IConferenceItem } from '../../interfaces/Conference';
import { Link, Links, Title, TitleSymbol, Wrapper } from './ConferencePrevious.elements';

interface ConferenceProps {
    colors?: IColors;
    conf?: IConferenceItem;
}

const ConferencePreviousTemplate: FC<ConferenceProps> = ({ colors, conf }) => {
    const { t } = useTranslations();

    return (
        <Wrapper id={`confSection${COMPONENT_TYPE.ARCHIVE}`} colors={colors}>
            <Title colors={colors}>
                {t('conference.component.previous.title')} <TitleSymbol colors={colors} />
            </Title>

            {conf?.conference?.archives.length > 0 && (
                <Links>
                    {conf?.conference?.archives.map((item, index) => (
                        <Link href={item.conference.url} target="_blank" colors={colors} key={`${item.conference.name}${index}`}>
                            {item.conference.name}
                        </Link>
                    ))}
                </Links>
            )}
        </Wrapper>
    );
};

export default ConferencePreviousTemplate;
